import React from 'react';
import { Link } from 'gatsby';
import { getSiteConfig } from '../../siteConfig';

export const getLink = (link) => {
  if (!link) {
    return '/';
  }

  link = link.replace(/^(fi|no)/, '');
  return link.match(/^\/(home)/)
    ? `/`
    : `${link.startsWith('/') ? '' : '/'}${link}${
        link.endsWith('/') ? '' : '/'
      }`;
};

export const LinkWrapper = ({ children, ...props }) => {
  const { link, onClick, className, trackingId } = props;
  if (link) {
    if (link.linktype === 'story') {
      let href = '';
      const lang = getSiteConfig().storyblokLanguage;
      if (lang === 'default') {
        if (link.story && link.story.full_slug) {
          href = `${getLink(link.story.full_slug)}${
            link.anchor ? `#${link.anchor}` : ''
          }`;
        } else {
          href = `${getLink(link.cached_url || link.href)}${
            link.anchor ? `#${link.anchor}` : ''
          }`;
        }
      } else {
        if (link.story && link.story.alternates) {
          const linkPath = link.story.alternates.find(
            (langObj) => langObj.lang === lang,
          ).path;
          href = `${getLink(linkPath)}${link.anchor ? `#${link.anchor}` : ''}`;
        }
      }
      return (
        <Link
          to={href}
          className={className}
          aria-label="Link"
          data-tracking-id={trackingId}
        >
          {children}
        </Link>
      );
    } else if (link.linktype === 'anchor') {
      return (
        <a
          href={`#${link.anchor}`}
          className={className}
          aria-label="Link"
          data-tracking-id={trackingId}
        >
          {children}
        </a>
      );
    } else if (link.linktype === 'email') {
      return (
        <a
          href={`mailto:${link.url}`}
          className={className}
          aria-label="Link"
          data-tracking-id={trackingId}
        >
          {children}
        </a>
      );
    } else {
      const href = link.url || link.href;
      return (
        <a
          href={href}
          className={className}
          aria-label="Link"
          data-tracking-id={trackingId}
        >
          {children}
        </a>
      );
    }
  } else if (onClick) {
    return (
      <button
        onClick={onClick}
        className={className}
        aria-label="Button"
        data-tracking-id={trackingId}
      >
        {children}
      </button>
    );
  } else {
    console.log('wtf?');
  }
};
